/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import Loading from "../../../components/shared/loading/Loading";
import { updateData } from "../../../hooks/update";
import useFetch from "../../../hooks/useFetch";
import { apiPath, RoutePath } from "../../../utility/Constant";

const ManagementsUniquePage = () => {
  const { managementsApi } = apiPath;
  const { aboutUsManagementsList } = RoutePath;

  const [managementsUniqueData, managementsUniqueLoading] =
    useFetch(managementsApi);
  const [filteredData, setFilteredData] = useState();
  let { id } = useParams();

  useEffect(() => {
    setFilteredData(
      managementsUniqueData?.filter((item) => item._id === id)[0]
    );
  }, [managementsUniqueData, id]);

  if (managementsUniqueLoading || !filteredData?._id) {
    return <Loading />;
  }

  const { subtitle, title, description, image, _id } = filteredData ?? {};

  const data = [
    {
      elementType: "input",
      label: "Name",
      type: "Text",
      name: "title",
      defaultValue: title,
      required: false,
    },
    {
      elementType: "input",
      label: "Position",
      type: "Text",
      name: "subtitle",
      defaultValue: subtitle,
      required: false,
    },
    {
      elementType: "textField",
      label: "description",
      type: "Text",
      name: "description",
      defaultValue: description,
      required: false,
    },
    {
      elementType: "file",
      label: `Image`,
      name: "image",
      type: "file",
      fullCol: true,
      defaultValue: image,
      required: false,
    },
  ];

  const update = (data) => {
    const { image, ...rest } = data;
    rest.image = {
      url: image,
    };
    updateData(managementsApi, rest, _id);
    setTimeout(() => {
      window.location.href = `/${aboutUsManagementsList}`;
    }, 800);
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default ManagementsUniquePage;
